import React, { ReactNode } from 'react';
import styles from './AccessoryGrid.module.scss';

interface AccessoryGridProps {
  children: ReactNode;
  className?: string;
}

export const AccessoryGrid = ({ children, className = '' }: AccessoryGridProps) => {
  return (
    <div className={`${styles.accessoryGrid} ${className}`} draggable="false">
      {children}
    </div>
  );
};